var _g, _path, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBikePtWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.529 1417.96a2.31 2.31 0 0 1 -2.305-2.316 2.311 2.311 0 0 1 2.316-2.305 2.311 2.311 0 0 1 2.305 2.316 2.308 2.308 0 0 1 -2.312 2.3z",
    strokeLinejoin: "round",
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-7.978 1425.493a4.76 4.76 0 0 1 4.76-4.76",
    strokeLinejoin: "round",
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.6 1427.872c2.508 0 4.538 3.2 4.538 7.156",
    strokeLinejoin: "round",
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.542 1425.493a4.76 4.76 0 0 1 -4.76-4.76",
    strokeLinejoin: "round",
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.61 18.251-4.76 14.278",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-43.39 1425.6a4.438 4.438 0 0 1 4.437 4.438 4.437 4.437 0 0 1 -4.438 4.437 4.437 4.437 0 0 1 -4.437-4.437 4.437 4.437 0 0 1 4.437-4.438zm14.521 0a4.438 4.438 0 0 1 4.437 4.438 4.437 4.437 0 0 1 -4.437 4.437 4.437 4.437 0 0 1 -4.438-4.437 4.438 4.438 0 0 1 4.438-4.438zm-14.521 4.44 3.992-5.111 7.348-.744m1.216-2.07-2.068.148 4.03 7.772m-12.51-7.2h2.568",
    strokeLinejoin: "round",
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-28.309 1404.257 1.446-.7a1.325 1.325 0 0 1 .459-.079h8.612a1.3 1.3 0 0 1 .453.079l1.446.7",
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.845 1v3.186"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-15.783 1425.814a1.082 1.082 0 0 1 1.083 1.086 1.082 1.082 0 0 1 -1.083 1.081 1.083 1.083 0 0 1 -1.082-1.081 1.084 1.084 0 0 1 1.082-1.086z",
    fill: "#3a3a3a",
    transform: "translate(48.828 -1402.482)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-31.442 1412.427c0-.373.55-.648 1.208-.679 5.792-.268 10.477-.229 16.268 0 .659.026 1.207.307 1.207.679",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-12.761 1421.6c0 .932-8.829 1.226-14.347.876",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-31.442 1419.2v-8.612a3.9 3.9 0 0 1 3.843-3.938v.006h10.999a3.9 3.9 0 0 1 3.843 3.938v18.626a2.6 2.6 0 0 1 -2.243 2.161 67.756 67.756 0 0 1 -7.1.373",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    transform: "translate(48.828 -1402.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.784 32.024h8.47",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikePtWalk);
export default __webpack_public_path__ + "static/media/bike-pt-walk.59a0029a2bc895ed292321747866df1a.svg";
export { ForwardRef as ReactComponent };